import { VideoJsPlayerOptions } from 'video.js';

const options: VideoJsPlayerOptions = {
  preload: 'auto',
  // 'any' asks the browser for autoplay with sound and, when it is blocked, retries muted so
  // playback always starts. UnmuteNotice then asks the viewer for the click browsers require
  // before the sound can be turned on. Autoplay with sound is only attempted while not muted.
  autoplay: 'any',
  muted: false,
  errorDisplay: false,
  retryOnError: true,
  controls: false,
  bigPlayButton: false,
  disablePictureInPicture: true,
  html5: {
    vhs: {
      handleManifestRedirects: true,
      overrideNative: true,
      enableLowInitialPlaylist: true,
      maxPlaylistRetries: 3,
    },
    // nativeAudioTracks: false,
    // nativeVideoTracks: false,
    // nativeTextTracks: false,
  },
  // userActions: {
  //   hotkeys: function (event) {
  //     const playerVolume = this.volume();
  //     const playerCurrentTime = this.currentTime();
  //     console.log(event.code);
  //     switch (event.code) {
  //       case 'Space':
  //         if (this.paused()) {
  //           this.play();
  //         } else {
  //           this.pause();
  //         }
  //         break;
  //       case 'ArrowRight':
  //         this.currentTime(playerCurrentTime + 15);
  //         break;
  //       case 'ArrowLeft':
  //         this.currentTime(playerCurrentTime - 15);
  //         break;
  //       case 'ArrowUp':
  //         this.volume(playerVolume + 0.1);
  //         break;
  //       case 'ArrowDown':
  //         this.volume(playerVolume - 0.1);
  //         break;
  //       case 'KeyM':
  //         this.volume(playerVolume === 0 ? 1 : 0);
  //         break;
  //       default:
  //         return;
  //     }
  //   },
  // },
};

export default options;
